import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import { onImgError } from "@/lib/images";

export function ProductsGrid() {
  return (
    <section
      className="bg-vortex-alt py-24"
      data-testid="home-products-section"
    >
      <div className="container-wide">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="section-label mb-4">Our Products</div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-vortex-navy tracking-tighter leading-[1.05]">
              Industrial-grade power products, engineered in Chennai.
            </h2>
          </div>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 font-semibold text-vortex-navy hover:text-vortex-blue transition-colors group"
            data-testid="home-view-all-products"
          >
            View All Products
            <ArrowUpRight
              className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              strokeWidth={2}
            />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
            >
              <Link
                to={`/products/${p.slug}`}
                className="group block bg-white rounded-2xl overflow-hidden border border-vortex-border shadow-[0_8px_30px_rgba(0,65,90,0.04)] hover:shadow-[0_20px_40px_rgba(0,65,90,0.08)] hover:-translate-y-2 transition-all duration-300"
                data-testid={`home-product-card-${p.slug}`}
              >
                <div className="aspect-[4/3] bg-vortex-alt overflow-hidden relative">
                  <img
                    src={p.image}
                    onError={onImgError}
                    alt={p.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-[10px] font-bold uppercase tracking-widest bg-white/90 backdrop-blur text-vortex-navy px-2.5 py-1 rounded-full">
                      Category
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-heading font-bold text-xl text-vortex-navy group-hover:text-vortex-blue transition-colors mb-2">
                    {p.name}
                  </h3>
                  <p className="text-sm text-vortex-slate leading-relaxed line-clamp-2 mb-5">
                    {p.short}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-vortex-border">
                    <span className="text-sm font-semibold text-vortex-navy group-hover:text-vortex-orange transition-colors">
                      Read More
                    </span>
                    <div className="w-8 h-8 rounded-full bg-vortex-alt group-hover:bg-vortex-orange text-vortex-navy group-hover:text-white flex items-center justify-center transition-colors">
                      <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
